import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserInvitation, ClientLocation, Client } from '../../clients-module/models/clientLocation';
import { ChannelService } from '../../services/channel.service';
import { ToastrService } from 'ngx-toastr';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { ClientService } from '../../clients-module/services/client.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription } from 'rxjs';
import { PropertyService } from 'src/app/property-module/services/property.service';

@Component({
  selector: 'app-users-add',
  templateUrl: './users-add.component.html',
  styleUrls: ['./users-add.component.less']
})
export class UsersAddComponent implements OnInit, OnDestroy {
  ngOnDestroy(): void {

  }
  invite : UserInvitation = new UserInvitation();
  invalidFields : Array<any> = new Array<any>();
  hidebutton: boolean
  listner$ : Subject<any>;
  sub : Subscription;
  clientId : number;
  public clientList: Client[] = [];
  constructor(public auth: AuthService, 
    private location: Router, 
    private activatedRoute: ActivatedRoute, 
    public clients: ClientService, 
    public screening: ScreeningService, 
    private toast: ToastrService, 
    public props : PropertyService,
    private channels: ChannelService) {
    // if(!this.auth.isAuthenticated)this.auth.logout();

  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      this.clientId = parseInt(p.get('client'));
      if(this.clientId) {
        this.props.FetchPropertiesForClient(this.clientId);
        this.invite.clientId = this.clientId;
        //this.invite.initiatingUserId = this.auth.loggedInUser.id; -- NOTE: this gets set in the API based on the user context there, not needed here
      }
      //if it's a CRA, regardless of how they're navigating to the user add page, we need to fetch the clientList
      if(this.auth.UserInRole('CRA')) {
        this.clients.FetchLightClientList().subscribe((res: Client[]) => {
          this.clientList = res.filter(c =>{ return c.isActive;});
        })
      }

    });
    
  }

  onClientSelect(): void {
    this.props.FetchPropertiesForClient(this.invite.clientId);
    this.removeValidation('clientId');
  }

  getFieldValidationMessage(fieldName : string) : string{
    return this.invalidFields.find(e =>{return e.name == fieldName}).msg;
  }

  isFieldValid(fieldName : string) : boolean{
    return this.invalidFields.find(e =>{return e.name == fieldName}) == undefined;
  }

  runValidation() : boolean {
    if(!this.invite.firstName) {
      if(this.invalidFields.find(e =>{return e.name == 'firstName'}) == undefined){
        this.invalidFields.push({
          name : 'firstName',
          msg : 'User First Name is required'
        })
      }
    }else{
      this.removeValidation('firstName');
    }

    if(!this.invite.lastName) {
      if(this.invalidFields.find(e =>{return e.name == 'lastName'}) == undefined){
        this.invalidFields.push({
          name : 'lastName',
          msg : 'User Last Name is required'
        })
      }
    }else{
      this.removeValidation('lastName');
    }

    let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    if(!this.invite.email || !emailRegex.test(this.invite.email)) {
      if(this.invalidFields.find(e =>{return e.name == 'email'}) == undefined){
        this.invalidFields.push({
          name : 'email',
          msg : 'User Email is required and must be valid.'
        })
      }
    }else{
      this.removeValidation('email');
    }

    if(!this.invite.clientId) {
      if(this.invalidFields.find(e =>{return e.name == 'clientId'}) == undefined){
        this.invalidFields.push({
          name : 'clientId',
          msg : 'Client is required.'
        })
      }
    }else{
      this.removeValidation('clientId');
    }

    if(this.invalidFields.length > 0) return false;
    else return true;
  }

  updateClientLocation(s: ClientLocation){
    if(this.locationIncluded(s)){
      this.invite.properties.splice(this.invite.properties.indexOf(s),1)
    }else this.invite.properties.push(s);
  }
  
locationIncluded(s : ClientLocation){
  return this.invite.properties.indexOf(s) >-1;  
}

  update(s: any) {
    this.removeValidation(s.name);
    this.invite[s.name] = s.value;
  }

  assignAll() : void {
    this.props.activeProperties.forEach(prop => {
      if(this.locationIncluded(prop)) return;
      else this.updateClientLocation(prop);
    });
  }

  removeAll() : void {
    this.props.properties.forEach(prop => {
      if(!this.locationIncluded(prop)) return;
      else this.updateClientLocation(prop);
    });
  }

  removeValidation(fieldName: string) {
    let invalidFieldcheck = this.invalidFields.find(e =>{return e.name == fieldName});
    if(this.invalidFields.indexOf(invalidFieldcheck) > -1){
      this.invalidFields.splice(this.invalidFields.indexOf(invalidFieldcheck),1);
    }
  }

  sendUserInvite(){
    if(this.runValidation()) {
      this.auth.CreateUserInvite(this.invite).subscribe((rsp: any) => {
        this.toast.success(`Your invitation has been sent to ${this.invite.firstName} ${this.invite.lastName}.`, 'Invitation Sent');
        this.location.navigateByUrl('/users');
      },
        (err: any) => {
          this.toast.error(`Your invitation has failed to send to ${this.invite.firstName} ${this.invite.lastName}.`, '', { disableTimeOut: true, closeButton: true});
          if(err.status == 401){
            this.location.navigateByUrl('auth');
          }
        });
      }
  }

}
